import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AliasService {
  private aliasController: IAliasControlStrategy = new AliasControlLuhnStrategy();
  public onStrategyChange$ = new Subject();

  constructor() { }

  setAliasStrategyLuhn(){
    this.aliasController = new AliasControlLuhnStrategy();
    this.onStrategyChange$.next();
  }

  setAliasStrategyMod10(){
    this.aliasController = new AliasControlModStrategy();
    this.onStrategyChange$.next();
  }

  aliasControl(aliasNo:any): boolean {
    return this.aliasController.aliasControl(aliasNo);
  }

  getFormattedAlias(alias: string): string{
    return this.aliasController.getFormattedAlias(alias);
  }

  formatAlias(oldAliasNo:any, newAliasNo:any) {
    const isDeleted =
      oldAliasNo === newAliasNo + '-' && oldAliasNo.length > newAliasNo.length;
    if (isDeleted) {
      return newAliasNo;
    }
    if (newAliasNo.length === 20) return oldAliasNo;
    else if (newAliasNo.length > 13) {
      var v = newAliasNo.replace(/\s+/g, '').replace(/[^0-9]/gi, '');
      var matches = v.match(/\d{4,16}/g);
      var match = matches && (matches[0] || '');
      var parts = [];

      for (let i = 0, len = match.length; i < len; i += 4) {
        parts.push(match.substring(i, i + 4));
      }

      if (parts.length) {
        return parts.join(' ');
      } else {
        return newAliasNo;
      }
    }
    newAliasNo = newAliasNo.replace(/ /g, '');
    const splitText = newAliasNo.split('-');
    if (splitText.length === 1) {
      // eger "-" ifadesi bulunmuyor ise
      if (newAliasNo.length === 5) {
        // 5. karaktere geldi ise
        return newAliasNo + '-';
      } else if (newAliasNo.length === 6) {
        // 6. karaktere geldi "-" işareti yok ise
        return newAliasNo.slice(0, -1) + '-' + newAliasNo.slice(-1);
      } else {
        // normal durumda ise
        let cache = newAliasNo;
        if (newAliasNo.length > 5) {
          // eğer hızlı yazıldı ve 5. elemandan sonra "-" ifadesi eklenmedi ise
          cache = cache.slice(0, 5) + '-' + cache.slice(5, cache.length);
        }
        if (newAliasNo.length > 12) {
          cache = cache.slice(0, 11) + '-' + cache.slice(11, cache.length);
        }
        if (
          newAliasNo.length < oldAliasNo.length &&
          newAliasNo.replace(/\D/g, '').length === 11
        ) {
          return `${cache.slice(0, cache.length - 1)}-${
            cache[cache.length - 1]
          }`;
        }
        return cache;
      }
    } else if (splitText.length === 2) {
      // eger  bir tane "-" ifadesi bulunuyor ise
      if (splitText[0].length < 6) {
        // eger ilk tireden önceki ifade 6 karakterden küçük ise
        if (newAliasNo.length === 11) {
          // 11. karaktere geldi ise
          return newAliasNo + '-';
        } else if (newAliasNo.length === 12) {
          // 12. karaktere geldi ve hala 1 tane "-" işareti var ise
          return newAliasNo.slice(0, -1) + '-' + newAliasNo.slice(-1);
        } else {
          // normal durumda ise
          let cache = newAliasNo;
          if (newAliasNo.length > 12) {
            cache = cache.slice(0, 11) + '-' + cache.slice(11, cache.length);
          }
          return cache;
        }
      } else {
        // eger ilk tireden önceki ifade 6 karakterden küçük değil ise
        return oldAliasNo;
      }
    } else if (splitText.length === 3) {
      // eger  iki tane "-" ifadesi bulunuyor ise
      if (splitText[0].length < 6 && splitText[1].length < 6) {
        // eger ilk tireden önceki ifade 6 karakterden küçük ise ve 2. tire ile arasında 5 karakter var ise
        if (splitText[2].length < 2) {
          return newAliasNo;
        } else {
          return oldAliasNo;
        }
      } else {
        // Eger tireler arasında fazla karakter yazılmış ise
        return oldAliasNo;
      }
    } else {
      return oldAliasNo;
    }
  }

  reformatAlias(aliasNo:any) {
    /*
      formatter(aliasNo) EXAMPLE:
      Entry = 33800-00002-6
      Output = 3380000002
    */
    const newAlias = aliasNo.split('-').join('');
    return newAlias.substring(0, 10);
  }

}

export interface IAliasFormatter{
  getFormattedAlias(alias: string): string
}

export interface IAliasControlStrategy extends IAliasFormatter{
  aliasControl(aliasNo:any): boolean
}

abstract class AliasFormatter implements IAliasFormatter{
  getFormattedAlias(alias: string){
    let sum = 0;
    let lastDigit = 0;
    for (let i = 0; i < alias.length; i += 1) {
      sum += Number(alias.charAt(i));
    }
    return `${alias.substring(0, 5)}-${alias.substring(5)}-`;
  }
}

export class AliasControlModStrategy extends AliasFormatter implements IAliasControlStrategy{
  aliasControl(aliasNo:any): boolean {
      let state: boolean = false;
      const intArray:Array<any> = [];
      let toplam = 0;
      let lastDigit = 0;
      let modDigit = 0;
  
      // Sayının Rakamlarını intArray Dizisine Pushlama İşlemi
      const b = aliasNo.split('').map(function (item:any) {
        intArray.push(parseInt(item, 10));
      });
  
      for (let i = 0; i < 5; i += 1) {
        toplam += intArray[i];
      }
  
      for (let i = 6; i < 11; i += 1) {
        toplam += intArray[i];
      }
  
      lastDigit = intArray[12];
      modDigit = toplam % 10;
  
      /*
        STATE TRUE dönüyorsa girilen alias numarası DOĞRU
        STATE FALSE dönüyorsa girilen alias numarası YANLIŞ
      */
      if (lastDigit === modDigit) {
        state = true;
      }
  
      return state;
  }

  private getCheckDigit(alias: string){
    return String(Number(alias) % 10);
  }

  getFormattedAlias(alias: string): string {
    return super.getFormattedAlias(alias) + this.getCheckDigit(alias);
  }

}

export class AliasControlLuhnStrategy extends AliasFormatter implements IAliasControlStrategy{
  aliasControl(aliasNo:any): boolean {
      const formattedAlias: string = aliasNo.split('-').join('').substring(0, 10);
      const lastDigit = aliasNo.charAt(aliasNo.length - 1);

      const remainder = this.getCheckDigit(String(formattedAlias)); 
      
      if(Number(lastDigit) === Number(remainder)){
          return true;
      }else{
          return false;
      }
  }

  private getCheckDigit(value: string){
      if (/[^0-9-\s]+/.test(value)) return false;

      var nCheck = 0, nDigit = 0, bEven = true;
      value = value.replace(/\D/g, "");
    
      for (var n = value.length - 1; n >= 0; n--) {
        var cDigit = value.charAt(n),
          nDigit = parseInt(cDigit, 10);
    
        if (bEven) {
          if ((nDigit *= 2) > 9) nDigit -= 9;
        }
    
        nCheck += nDigit;
        bEven = !bEven;
      }
      return (1000 - nCheck) % 10;
  }

  getFormattedAlias(alias: string): string {
    return super.getFormattedAlias(alias) + this.getCheckDigit(alias);
  }

}